import { render, staticRenderFns } from "./PerseuCard.vue?vue&type=template&id=058fadc3&scoped=true&"
import script from "./PerseuCard.vue?vue&type=script&lang=js&"
export * from "./PerseuCard.vue?vue&type=script&lang=js&"
import style0 from "./PerseuCard.vue?vue&type=style&index=0&id=058fadc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058fadc3",
  null
  
)

export default component.exports